var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "edit_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#edit_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#333133",
  d: "M7.276 16.556h1.03l7.06-7.06-1.03-1.03-7.06 7.06zM5.832 18v-3.07l9.533-9.515q.217-.198.479-.307.261-.108.55-.108t.56.108.47.325l.993 1.011q.216.2.316.47a1.56 1.56 0 0 1 0 1.092 1.35 1.35 0 0 1-.316.479L8.9 18zm9.01-9.01-.506-.523 1.03 1.029z"
}))));
export default SvgEdit;